import MailScopeRequest from 'src/adminPanel/entities/it/mail/MailTemplateScopeRequest';
import { action } from 'src/store/actions';

export const FETCH_MAIL_TEMPLATES = 'FETCH_MAIL_TEMPLATES';
export const REQUEST_MAIL_TEMPLATES = 'REQUEST_MAIL_TEMPLATES';
export const SUCCESS_FETCH_MAIL_TEMPLATES = 'SUCCESS_FETCH_MAIL_TEMPLATES';
export const FAILURE_FETCH_MAIL_TEMPLATES = 'FAILURE_FETCH_MAIL_TEMPLATES';
export const ADD_NEW_MAILSCOPE_TO_MAILKEY = 'ADD_NEW_MAILSCOPE_TO_MAILKEY';
export const DELETE_MAILSCOPE = 'DELETE_MAILSCOPE';
export const FETCH_PREVIEW_OF_MAIL_TEMPLATE = 'FETCH_PREVIEW_OF_MAIL_TEMPLATE';
export const REQUEST_PREVIEW_OF_MAIL_TEMPLATE = 'REQUEST_PREVIEW_OF_MAIL_TEMPLATE';
export const SUCCESS_FETCH_PREVIEW_OF_MAIL_TEMPLATE = 'SUCCESS_FETCH_PREVIEW_OF_MAIL_TEMPLATE';
export const FAILURE_FETCH_PREVIEW_OF_MAIL_TEMPLATE = 'FAILURE_FETCH_PREVIEW_OF_MAIL_TEMPLATE';

export const fetchMailTemplates = () => action(FETCH_MAIL_TEMPLATES);
export const requestMailTemplates = () => action(REQUEST_MAIL_TEMPLATES);
export const requestFetchMailTemplatesSuccess = (response: any) => action(SUCCESS_FETCH_MAIL_TEMPLATES, { response });
export const requestFetchMailTemplatesFailure = (error: any) => action(FAILURE_FETCH_MAIL_TEMPLATES, { error });

/* Mailscopes */
export const addNewMailscope = (mailScopeRequest: MailScopeRequest) =>
    action(ADD_NEW_MAILSCOPE_TO_MAILKEY, { mailScopeRequest });
export const deleteMailscope = (mailScopeId: string) => action(DELETE_MAILSCOPE, { mailScopeId });

/* Mail Preview */
export const fetchPreviewOfMailTemplate = (
    mailTemplate: string,
    mailScopes: Record<string, string>,
    region: string,
    language: string
) => action(FETCH_PREVIEW_OF_MAIL_TEMPLATE, { mailTemplate, mailScopes, region, language });
export const requestPreviewOfMailTemplate = () => action(REQUEST_PREVIEW_OF_MAIL_TEMPLATE);
export const requestPreviewOfMailTemplateSuccess = (response: any) =>
    action(SUCCESS_FETCH_PREVIEW_OF_MAIL_TEMPLATE, { response });
export const requestPreviewOfMailTemplateFailure = (error: any) =>
    action(FAILURE_FETCH_PREVIEW_OF_MAIL_TEMPLATE, { error });

/* send Mail Preview */
export const SEND_MAIL_PREVIEW_TO_RECEIVER = 'SEND_MAIL_PREVIEW_TO_RECEIVER';
export const REQUEST_SEND_MAIL_PREVIEW_TO_RECEIVER = 'REQUEST_SEND_MAIL_PREVIEW_TO_RECEIVER';
export const SUCCESS_SEND_MAIL_PREVIEW_TO_RECEIVER = 'SUCCESS_SEND_MAIL_PREVIEW_TO_RECEIVER';
export const FAILURE_SEND_MAIL_PREVIEW_TO_RECEIVER = 'FAILURE_SEND_MAIL_PREVIEW_TO_RECEIVER';

export const sendMailPreviewToReceiver = (
    mailKey: string,
    receivers: string[],
    scopes: Record<string, string>,
    region: string,
    language: string
) => action(SEND_MAIL_PREVIEW_TO_RECEIVER, { mailKey, receivers, scopes, region, language });
export const requestSendMailPreviewToReceiver = () => action(REQUEST_SEND_MAIL_PREVIEW_TO_RECEIVER);
export const requestSendMailPreviewToReceiverSuccess = (response: any) =>
    action(SUCCESS_SEND_MAIL_PREVIEW_TO_RECEIVER, { response });
export const requestSendMailPreviewToReceiverFailure = (error: any) =>
    action(FAILURE_SEND_MAIL_PREVIEW_TO_RECEIVER, { error });
